module.exports = __webpack_public_path__ + "img/animat-diamond-color.c63f6841.gif";